import React, { useCallback } from "react";
import classNames from "classnames";
import { useTheme } from "./theme";

interface TextInputProps {
  autoFocus?: boolean;
  name?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onSubmitEditing?: () => void;
  onFocusOut?: () => void;
  invalid?: boolean;
  direction?: "ltr" | "rtl";
}

export function TextInput(props: TextInputProps) {
  const {
    placeholder,
    autoFocus,
    invalid,
    name,
    value,
    onChange,
    direction,
    onSubmitEditing,
    onFocusOut,
  } = props;
  const theme = useTheme();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.currentTarget.value);
    },
    [onChange]
  );

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      // Enter
      if (onSubmitEditing && e.key === "Enter") {
        onSubmitEditing();
      }
    },
    [onSubmitEditing]
  );

  return (
    <input
      dir={direction}
      autoFocus={autoFocus}
      className={classNames("text-input", invalid && "text-input-invalid")}
      name={name}
      value={value}
      onBlur={onFocusOut}
      placeholder={placeholder}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      type="text"
      style={{ fontFamily: theme.fontFamilyBody }}
    />
  );
}
